import React from 'react';
import { useTranslation } from 'react-i18next';
import { yesblank } from '../../utils/textFormat';

const CheckpointComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.checkpoint_type) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          <tr>
            <th>Checkpoint Type</th>
            <td>{t(`checkpoint.${report.checkpoint_type.toLowerCase()}`)}</td>
          </tr>
          <tr>
            <th>Armed</th>
            <td>{yesblank(report.checkpoint_subtypes.includes('armed'))}</td>
          </tr>
          <tr>
            <th>Blocked</th>
            <td>{yesblank(report.checkpoint_subtypes.includes('blocked'))}</td>
          </tr>
          <tr>
            <th>Technical</th>
            <td>{yesblank(report.checkpoint_subtypes.includes('technical_present'))}</td>
          </tr>
          <tr>
            <th>Personnel</th>
            <td>{report.personnel}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default CheckpointComponent;
